import { useState, useEffect } from 'react';
import {
  init,
  setupBeamerConfig,
  updateUserId,
  isInitialised,
} from '@hotjar/webapp/features/ProductUpdates';
import { useTranslation } from 'react-i18next';

export function useProductUpdatesCount(currentUser?: { id: number }): number {
  const [notificationCount, setNotificationCount] = useState(0);
  const { i18n } = useTranslation();
  const currentLanguage = i18n.resolvedLanguage ?? 'en';

  useEffect(() => {
    // Needed for the Beamer plugin to work in the app.
    if (!isInitialised()) {
      setupBeamerConfig(currentLanguage, setNotificationCount);
      init(() => {
        if (currentUser) {
          updateUserId(currentUser.id);
        }
      });
    }

    global.Beamer?.update({ language: currentLanguage });
  }, [currentUser, currentLanguage]);

  return notificationCount;
}
